<template>
  <div class="about">
    <Tab ref="tab" :class="{ blur: isSearch, 'swiper-bg': hasBg }"></Tab>

    <div class="main" @mouseover="tabMiss" :class="{ blur: isSearch }">
      <router-view></router-view>
    </div>


    <Search v-show="isSearch"></Search>

    <navigationsMap v-if="mapShow"></navigationsMap>
    <bottom-text></bottom-text>

  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import navigationsMap from '@/components/navigations-map'
import Tab from '@/components/tab-commonality'
import Search from '@/components/search'
import BottomText from '@/components/bottom-text'

export default {
  name: 'about',

  components: {
    navigationsMap,
    Tab,
    Search,
    BottomText,
  },

  data() {
    return {
      currentPath: null,
      hasBg: true,
    }
  },

  computed: {
    ...mapState('about', [
      'routeNames'
    ]),

    ...mapState('home', [
      'isSearch',
      'mapShow'
    ]),

    navigations() {
      return this.$i18n.messages[this.$i18n.locale].messages.about.navigations
    }
  },

  created() {
    if (location.pathname === '/about') {
      this.$router.replace('/about/profile')
    }
  },

  mounted() {
    document.documentElement.scrollTop = 0
    this.SETUP_TAB_BG({
      type: true
    })
    this.currentPath = this.$route.name
    this.SETUP_TAB({
      tab: {
        en: 'About',
        cn: '研究院概况'
      }
    })
  },

  watch: {
    $route() {
      this.currentPath = this.$route.name
    },
  },

  methods: {
    ...mapActions('about', [
    ]),

    ...mapMutations('home', [
      'SETUP_TAB',
      'SETUP_TAB_BG'
    ]),

    ...mapMutations('about', [
    ]),

    tabMiss() {
      if (this.$refs.tab) {
        this.$refs.tab.hoverMiss()
      }
    },

    jump(nav) {
      document.documentElement.scrollTop = 0
      this.$router.push(`/about/${nav.path}`)
      this.currentPath = nav.path
    }

  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/colors.less';
@import '~@/styles/second-menu.less';

.about {
  @nav_height: 48px;
  width: 100%;
  height: calc(100vh - 40px);
  min-height: 100vh;
  // background-image: linear-gradient(55deg, #171B3B 0%, #1E2141 48%, #392A6C 90%);
  background: @pageBg;
  background-position: left top;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;

  .main {
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    width: 100%;
    overflow-y: auto;
    // overflow-x: hidden;

    flex: 1;
  }
}
.menu {
  font-size: 30px;
  color: #fff;
  cursor: pointer;
}

.blur {
  filter: blur(10px);
}

.swiper-bg {
  background: @pageBg;
  //  background-image: linear-gradient(55deg, #1c203d 0%, #362c68 90%) !important;
}
</style>



// WEBPACK FOOTER //
// index.vue?1f42d3d8